
import { SendByEnum } from "../enums/sendByEnum";

import * as appsettings from "../appsettings";
import * as breadcrumb  from "../breadcrumb";
import * as form        from "../form";
import * as listbox     from "../listbox";
import * as main        from "../main";
import * as viewmode    from "../viewmode";

declare namespace History {
    interface State {
        data?: any;
        title?: string;
        url?: string;
    }

    function getState(): State;
}

let _msg_notsaved = "";

function addGroupToSelected(groupId: number): void {

    const lbSelected = $("#PreComMsg_CplSelected").data("kendoListBox");
    if (lbSelected == null || lbSelected == undefined) return;

    // check it is not already in selected list
    let found = false;
    const view = lbSelected.dataSource.view();

    for (let i = 0; i < view.length && !found; i++) {
        found = view[i].Type == '2' && view[i].GroupID == groupId;
    }
    if (found) return;

    // check it is in available (not selected) list
    const lbNotSelected = $("#PreComMsg_CplNotSelected").data("kendoListBox");
    if (lbNotSelected == null || lbNotSelected == undefined) return;

    let foundNS = false;
    const viewNS = lbNotSelected.dataSource.view();
    let iNS: number;

    for (iNS = 0; ((iNS < viewNS.length) && !foundNS); iNS++) {
        foundNS = viewNS[iNS].Type == '2' && viewNS[iNS].GroupID == groupId;
    }

    if (!foundNS) return;

    // set item as selected
    lbNotSelected.select(lbNotSelected.items()[iNS - 1]);

    // move it to the right-hand list (selected)
    LR_rightClicked();
}

function enabled(readOnly: boolean): void {
    if (readOnly) {
        viewmode.disableAllInputs("DivOverview");
    }
}

function visibility(): void {

    $("#SendButton").removeAttr("disabled");

    var ddlMsgType = $("#MsgType").data("kendoDropDownList");

    if (ddlMsgType != null && ddlMsgType != undefined) {

        if (ddlMsgType.value() == '2') {
            main.setHideDivBootstrap("DivPreDefinedMsg", false);
            main.setHideDivBootstrap("DivScenarioMsg", true);
        } else {
            main.setHideDivBootstrap("DivPreDefinedMsg", true);
            main.setHideDivBootstrap("DivScenarioMsg", false);
            main.setHideDivBootstrap("DivExtraInfo", false);
        }

    } else {
        main.setHideDivBootstrap("DivPreDefinedMsg", false);
        main.setHideDivBootstrap("DivScenarioMsg", true);
    }

    loadLRGroupsAndUsers();
}

function loadLRGroupsAndUsers(): void {

    // get selected preComMsgScenarioMsgID
    let preComMsgScenarioMsgID = 0;

    const ddl = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined && ddl.value() != '') {
        preComMsgScenarioMsgID = Number(ddl.value());
    }

    $("#DivLeftRight").load(appsettings.getUrl("PreComMsgLog/GetGroupsAndUsers?preComMsgScenarioMsgID=" + preComMsgScenarioMsgID), function () {

        $("#availableSearchBox").on("input", function () {
            const listBox = $("#PreComMsg_CplNotSelected").data("kendoListBox");
            const searchString = $(this).val();
            listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
        });

        $("#selectedSearchBox").on("input", function () {
            const listBox = $("#PreComMsg_CplSelected").data("kendoListBox");
            const searchString = $(this).val();
            listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
        });
    });
}

export function initialize(readOnly: boolean): void {
    enabled(readOnly);
    visibility();
}

export function onMsgTypeChanged(): void {
    visibility();
}

export function onPredefinedMsgTypeChanged(): void {
    const textarea = $("#MessageTextArea").data("kendoTextArea");
    if (textarea != null && textarea != undefined) {
        textarea.value(this.value());
    }
}

export function onPreComMsgScenarioChanged(): void {
    refresh_PreComMsgScenarioMsg();
}

export function refresh_PreComMsgScenarioMsg(): void {
    const ddlPreComMsgScenarioMsg = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");

    if (ddlPreComMsgScenarioMsg != null && ddlPreComMsgScenarioMsg != undefined) {
        ddlPreComMsgScenarioMsg.dataSource.read();
    }
}

export function dataSelectedPreComMsgScenarioID(): { preComMsgScenarioID: number } {
    const ddlPreComMsgScenarioID = $("#PreComMsgScenarioID").data("kendoDropDownList");
    let preComMsgScenarioId = 0;

    if (ddlPreComMsgScenarioID != null && ddlPreComMsgScenarioID != undefined) {
        preComMsgScenarioId = Number(ddlPreComMsgScenarioID.value());
    }

    return { preComMsgScenarioID: preComMsgScenarioId };
}

export function onPreComMsgScenarioMsgChanged(e: kendo.ui.DropDownListEvent): void {

    // update LR users/groups
    loadLRGroupsAndUsers();

    // fill message
    updateTextAreaWithScenarioInfo();

    // show hide other options
    if (e.sender.select() == 0) {
        main.setHideDivBootstrap("DivExtraInfo", false);
    } else {
        main.setHideDivBootstrap("DivExtraInfo", true);
        loadExtraInfo();
    }
}

export function updateTextAreaWithScenarioInfo(): void {

    let precomMsgScenarioText = "";
    const pms = $("#PreComMsgScenarioID").data("kendoDropDownList");
    if (pms != null && pms != undefined && pms.select() > 0) {
        precomMsgScenarioText = pms.dataItem(pms.select()).Text;
    }

    const pmsm = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");
    if (pmsm != null && pmsm != undefined && pmsm.select() > 0) {
        precomMsgScenarioText += ", " + pmsm.dataItem(pmsm.select()).MessageText;

        const cb_Priority = document.getElementById("Priority") as HTMLInputElement;;
        if (cb_Priority) {
            cb_Priority.checked = pmsm.dataItem(pmsm.select()).Priority;
        }

        const cb_Response = document.getElementById("Response") as HTMLInputElement;
        if (cb_Response) {
            cb_Response.checked = pmsm.dataItem(pmsm.select()).Response;
        }

        const calGrp = pmsm.dataItem(pmsm.select()).CalculateGroupID;
        const cb_CalculateGroup = document.getElementById("CalculateGroup") as HTMLInputElement;
        if (cb_CalculateGroup) {
            cb_CalculateGroup.checked = (calGrp !== undefined && calGrp !== null) ? pmsm.dataItem(pmsm.select()).LCD : false;

            main.setHideDivBootstrap("DivDDLCalculateGroup", cb_CalculateGroup.checked);

            const ddlCalGrp = $("#DDL_CalculateGroup").data("kendoDropDownList");
            if (cb_CalculateGroup.checked && ddlCalGrp) {

                // find calGrp
                let found = false;
                let i: number;
                for (i = 0; (i < ddlCalGrp.dataSource.view().length) && !found; i++) {
                    found = ddlCalGrp.dataSource.view()[i].Value == calGrp;
                }

                if (found) {
                    ddlCalGrp.select(i);
                }
            }
        }
    }

    const textarea = $("#MessageTextArea").data("kendoTextArea");
    if (textarea) {
        textarea.value(precomMsgScenarioText);
    }
}

export function loadExtraInfo(): void {

    let precomMsgScenarioMsgID = 0;
    const ddlPreComMsgScenarioMsg = $("#PreComMsgScenarioMsgID").data("kendoDropDownList");

    if (ddlPreComMsgScenarioMsg) {
        precomMsgScenarioMsgID = Number(ddlPreComMsgScenarioMsg.value());
    }

    $("#DivExtraInfo").load(appsettings.getUrl("PreComMsgLog/GetExtraInfo?precomMsgScenarioMsgID=" + precomMsgScenarioMsgID));
}

export function onExtraInfoTextChanged(): void {

    // clear TextBox
    const textarea = $("#MessageTextArea").data("kendoTextArea");
    textarea.value("");

    // put messages in TextBox
    updateTextAreaWithScenarioInfo();

    let msgtxt = textarea.value();

    const extraInfoTexts = $("input[id^='ExtraInfoText_']");

    for (let i = 0; i < extraInfoTexts.length; i++) {

        const ddl = $("#ExtraInfoText_" + i).data("kendoDropDownList");
        if (ddl) {
            const lbl = $("#ExtraInfoLabel_" + i);
            msgtxt += ", " + lbl[0].textContent + ": " + ddl.dataItem(ddl.select()).Text;
        }
    }

    textarea.value(msgtxt);
}

export function onSentByChanged(e: kendo.ui.DropDownListEvent): void {

    let show = false;
    const valset = e.sender.value();

    switch (valset) {

        case SendByEnum.Email:
            show = false;
            break;

        case SendByEnum.PreComMsg:
            show = true;
            break;
    }

    main.setHideDivBootstrap("DivCBResponse", show);
    main.setHideDivBootstrap("DivCalculateGroup", show);
}

export function onCalculateGroupChanged(e: kendo.ui.CheckBoxEvent): void {

    const cb = $("#Response").data("kendoCheckBox");
    cb.check(true);

    main.setHideDivBootstrap("DivDDLCalculateGroup", e.sender.check());
}

export function onDDLCalculateGroupChanged(e: kendo.ui.DropDownListEvent): void {

    if (e.sender.value() != null && e.sender.value() != undefined) {
        addGroupToSelected(Number(e.sender.value()));
    }
}

export function onValidFromChanged(e: kendo.ui.CheckBoxEvent): void {
    main.setHideDivBootstrap("DivDTValidFrom", e.sender.check());
}

export function onSendButtonClicked(bSend: HTMLInputElement): void {
    bSend.disabled = true;
    
    const ddlSentBy = $("#DDL_SentBy").data("kendoDropDownList");
    const sentBy = ddlSentBy.dataItem(ddlSentBy.select()).Value;

    const cbPriority = $("#Priority").data("kendoCheckBox");
    const priority = cbPriority.check();

    const cbResponse = $("#Response").data("kendoCheckBox");
    const response = cbResponse.check();

    let calculateGroupID = null;
    const cbCalculateGroup = $("#CalculateGroup").data("kendoCheckBox");
    if (cbCalculateGroup.check()) {
        const ddlCalGrp = $("#DDL_CalculateGroup").data("kendoDropDownList");
        if (ddlCalGrp != null && ddlCalGrp != undefined) {
            calculateGroupID = ddlCalGrp.dataItem(ddlCalGrp.select()).Value;
        }
    }

    let validFrom = null;
    const cbValidFrom = $("#CB_ValidFrom").data("kendoCheckBox");
    if (cbValidFrom.check()) {
        validFrom = $("#DTValidFrom").data("kendoDateTimePicker").value().toUTCString();
    }

    const list = JSON.stringify($("#PreComMsg_CplSelected").data("kendoListBox").dataItems());

    const message = $("#MessageTextArea").data("kendoTextArea").value();

    $.ajax({
        type: "POST",
        data:
        {
            sentBy: sentBy,
            priority: priority,
            response: response,
            calculateGroupID: calculateGroupID,
            validFrom: validFrom,
            messageText: message,
            assigned: list
        },
        url: appsettings.getUrl("PreComMsgLog/Submit"),
        success: function (responseData) {

            form.showServerResponse("preComLogMsg", responseData, function () {

                bSend.disabled = false;

                if (responseData) {
                    if (responseData.Succesfully) {
                        // Get current state
                        const state = History.getState();

                        // Script go back one step
                        breadcrumb.NavigateTo((state.data.step))
                    }
                }
            });
        }
    });
}


//--- LR ------------------------------------------------------------//

export function LR_Initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function LR_LDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

export function LR_rightClicked(): void {
    enableSaveButton();
    listbox.moveItems("PreComMsg_CplNotSelected", "PreComMsg_CplSelected", "#LR_Validation", LR_LDataChangedNotSavedYet());
}

export function LR_leftClicked(): void {
    enableSaveButton();
    listbox.moveItems("PreComMsg_CplSelected", "PreComMsg_CplNotSelected", "#LR_Validation", LR_LDataChangedNotSavedYet());
}

function enableSaveButton(): void {
    var saveButton = $("#SaveButton");

    if (saveButton.length > 0) {
        saveButton.data("kendoButton").enable(true);
    }
}
